import React from 'react'
import './Toast.css'

const Toast = (props) => {
  return (
    <div className='toast-container'>
        <div className='toast-message'><h3>{props.message}</h3></div>
    </div>
  )
}

export default Toast